export const getFileType = (url) => {
  const fileNameWithParams = url
    .substring(url.lastIndexOf("/") + 1)
    .split("?")[0];
  const type = fileNameWithParams.split(".").pop();
  return type.toUpperCase();
};
